/** @format */

import { DOCUMENT } from '@angular/common';
import { AfterViewChecked, Component, Inject, Input, OnInit } from '@angular/core';
import { chain } from '@core/chain';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { BVPixelResponse, Review, selectBVPixel } from '@product-reviews/data-access';
import { UtilityService } from '@shared/utils/services';
import { KillswitchService } from '@shared/data-access/services';
import {
	BVEventObject,
	BVEventObjectName,
	BVEventObjectType,
	BVEventType,
	BVProduct
} from '../models';

@Component({
	selector: 'product-reviews-review-text',
	templateUrl: './review-text.component.html',
	styleUrl: './review-text.component.scss',
	standalone: false
})
export class ReviewTextComponent implements OnInit, AfterViewChecked {
	@Input() review: Review;
	@Input() highlightedWord = '';
	paragraphElement: HTMLElement;
	buttonElement: HTMLElement;
	selectBV$ = this.store.select(selectBVPixel);
	bvPixelResponse: BVPixelResponse;
	newReviewsEnhancement = false;
	hasLoaded = false;
	chainAbbr = '';

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private store: Store<BVPixelResponse>,
		private killSwitchService: KillswitchService,
		private readonly utilityService: UtilityService
	) {}

	/* Life-cycle hooks */
	ngOnInit() {
		this.selectBV$.pipe(take(1)).subscribe((bv: BVPixelResponse) => {
			this.bvPixelResponse = bv;
		});

		this.killSwitchService.getKillSwitchesEnvironment$().subscribe((data) => {
			this.newReviewsEnhancement = this.utilityService.checkKillSwitch(
				'newReviewsEnhancement',
				data,
				chain.chainIdentifierAbbr
			);
		});
		this.chainAbbr = chain.chainIdentifierAbbr;
	}

	ngAfterViewChecked() {
		if (this.hasLoaded) {
			return;
		}
		this.paragraphElement = this.document.querySelector(`#reviewText_${this.review.Id}`);
		const showMore: boolean =
			this.paragraphElement &&
			this.paragraphElement?.scrollHeight > this.paragraphElement?.clientHeight;
		if (this.paragraphElement && showMore) {
			this.buttonElement = this.document.querySelector(`#viewMoreButton_${this.review.Id}`);
			this.buttonElement.classList.add('enabled');
			this.hasLoaded = true;
		} else if (this.paragraphElement && !showMore) {
			this.hasLoaded = true;
		}
	}

	onKeydownEvent(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			this.toggleExpandedReview();
		}
	}

	handleBVPixel(): void {
		const bvObject: BVEventObject = {
			type: BVEventObjectType.USED,
			name: BVEventObjectName.READMORE,
			brand: this.bvPixelResponse.brand,
			productId: this.bvPixelResponse.productId,
			bvProduct: BVProduct.RATINGSANDREVIEWS,
			categoryId: this.bvPixelResponse.category,
			detail1: 'expand',
			detail2: 'mainReviews'
		};
		if (BV.pixel) {
			BV.pixel.trackEvent(BVEventType.FEATURE, bvObject);
		}
	}

	toggleExpandedReview(): void {
		if (this.newReviewsEnhancement) {
			this.handleBVPixel();
		}
		this.buttonElement?.classList.remove('enabled');
		this.paragraphElement?.classList.remove('line-clamp');
	}
}
